import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

export function getHealthRecordChart(userId, day) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/healthRecord/getChartData`,
            {},
            {
                params: {
                    userId,
                    day,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
